import React from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";

import {
  EmailSignUpForm,
  StyledInput,
  StyledButton,
} from "../common/emailSignUpForm";

const StyledAbout = styled.div`
  width: 75%;
  font-family: ${(props) => props.theme.font.sans};
  color: white;

  ${(props) => props.theme.responsive.mobile} {
    width: 35%;
  }
`;

const StyledTitle = styled.div`
  font-size: 0.6rem;
  font-weight: bold;
  text-transform: uppercase;
`;

const StyledBody = styled.div`
  margin-top: 0.5rem;
  font-size: 0.7rem;
`;

const StyledSignUpWrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
  font-family: ${(props) => props.theme.font.sans};
  display: flex;
  flex-direction: column;
  align-items: stretch;

  ${(props) => props.theme.responsive.mobile} {
    margin-bottom: 0px;
    margin-top: 60px;
  }

  ${StyledInput} {
    width: 100%;
    background-color: transparent;
    outline: none;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid ${(props) => props.theme.color.grey};
    color: white;
    font-size: 0.8rem;
    padding: 3px 0;

    &::placeholder {
      color: ${(props) => props.theme.color.grey};
    }

    &:focus {
      border-color: white;
    }
  }

  ${StyledButton} {
    flex-shrink: 0;
    display: flex;
    flex-wrap: nowrap;
    text-align: center;
    padding: 0.2rem 0.8rem;
    border-radius: 1px;
    font-size: 0.6rem;
    border: 1px solid ${(props) => props.theme.color.lightGrey};
    color: 1px solid ${(props) => props.theme.color.lightGrey};

    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }
`;

const StyledSignUpTitle = styled.div`
  font-size: 0.6rem;
  text-transform: uppercase;
  color: ${(props) => props.theme.color.lightGrey};
  margin-bottom: 0.6rem;
`;

export default function About() {
  const intl = useIntl();
  return (
    <StyledAbout>
      <StyledTitle>{intl.formatMessage({ id: `botbar.title` })}</StyledTitle>
      <StyledBody>
        {intl.formatMessage({ id: `botbar.description` })}
      </StyledBody>
      <StyledSignUpWrapper>
        <StyledSignUpTitle>
          {intl.formatMessage({ id: `botbar.email.title` })}
        </StyledSignUpTitle>
        <EmailSignUpForm />
      </StyledSignUpWrapper>
    </StyledAbout>
  );
}
